function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState, memo } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import classes from "../../../design-system/scss/components/notification.module.scss";
import Portal from "./Portal";
import NotificationBox from "./NotificationBox";
import { jsx as _jsx } from "react/jsx-runtime";
var notificationClasses = {
  enter: classes.enter,
  enterActive: classes['enter-active'],
  exit: classes.exit,
  exitActive: classes['exit-active']
};
var Notification = function Notification(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    show = _ref.show,
    title = _ref.title,
    onClick = _ref.onClick,
    action = _ref.action,
    ttl = _ref.ttl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showing = _useState2[0],
    setShowing = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    timer = _useState4[0],
    setTimer = _useState4[1];
  var stopTimer = function stopTimer() {
    return setTimer(clearTimeout(timer));
  };
  var startTimer = function startTimer() {
    setTimer(setTimeout(function () {
      return setShowing(false);
    }, ttl));
  };
  useEffect(function () {
    setShowing(show);
    if (show && ttl) {
      startTimer();
    } else if (!show) {
      stopTimer();
    }
  }, [show]);
  return /*#__PURE__*/_jsx(Portal, {
    children: /*#__PURE__*/_jsx(CSSTransition, {
      "in": showing,
      mountOnEnter: true,
      unmountOnExit: true,
      timeout: 300,
      classNames: notificationClasses,
      onExited: onClose,
      children: /*#__PURE__*/_jsx(NotificationBox, {
        title: title,
        onClick: onClick,
        action: action,
        onClose: function onClose() {
          return setShowing(false);
        },
        onMouseEnter: stopTimer,
        onMouseLeave: startTimer,
        children: children
      })
    })
  });
};
Notification.defaultProps = {
  show: false,
  onClose: function onClose() {},
  onClick: function onClick() {},
  action: null,
  ttl: 5000
};
Notification.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  ttl: PropTypes.number
};
export default /*#__PURE__*/memo(Notification);